import { Injector } from '@angular/core';
import { assert } from '@sama/js-core';
import { AbstractDragHandler } from '../../../cross-team-shared/annotation/shared/tool-helpers/abstract-drag-handler';
import { PointCloudContentStore } from '../../state/point-cloud-content-store';
import { deleteIfDefined } from '../../state/render-state';
import { getShapeForEventTracking } from '../../utils/misc-utils';
import {
  getLegalizedScale,
  vectorToPoint,
} from '../../utils/point-cloud-utils';

export class EditToolDragHandler extends AbstractDragHandler {
  private store: PointCloudContentStore;

  constructor(
    private controls: any, // should be `TransformControls`. See .d.ts file
    initialEvent: MouseEvent,
    injector: Injector,
  ) {
    super(initialEvent, injector);
    this.store = injector.get(PointCloudContentStore);

    this.store('render')('currentEditSource').set({
      scene: 'main view',
    });
  }

  protected onMouseMove(event: MouseEvent) {
    this.controls._onPointerMove(event);

    const box = this.controls.object;
    box.scale.fromArray(getLegalizedScale(vectorToPoint(box.scale)));
    this.store.updateFocusedLocationFromCuboidMesh(box);
  }

  protected override onMouseUp(event: MouseEvent) {
    this.controls._onPointerUp(event);
  }

  protected override complete() {
    const focusedCuboidStore = this.store.getFocusedShapeStore();
    assert(focusedCuboidStore, 'mouse up called from a non-existent cuboid');
    this.shellConnector.pushAndTrack({
      id: 'edit_shape_points',
      bucket: 'adjustment',
      method: this.store.state().render.editMode,
      source: 'edit_tool',
      shapes: [getShapeForEventTracking(focusedCuboidStore.state())],
    });
  }

  protected override cleanUp() {
    this.store('render')('currentEditSource').setUsing(deleteIfDefined);
    super.cleanUp();
  }
}
